module.exports = __webpack_public_path__ + "img/image-20.c9df2615.jpg";